var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"free-division"},[_c('VideoMode',{attrs:{"freeInfo":_vm.freeInfo},on:{"toPage":_vm.toPage}}),_vm._l((_vm.data),function(item,index){return _c('div',{staticClass:"free-division-item"},[_c('FreeItem',{attrs:{"data":item}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }